import { useMemo, useState } from 'react';
import {
  filterCarriersByType,
  getCarrierTypeOptions
} from 'helpers/carriers/carriers';

/**
 * carrier-type filter state for the by-state maps (Health / Off-Market Health / Ancillary)
 * @param carriersArray - carriers from the appointments store
 * @returns options, the selected type values, their setter and the carriers left after filtering
 */
export default function useCarrierTypeFilter(carriersArray) {
  const [selectedTypes, setSelectedTypes] = useState([]);

  const options = useMemo(
    () => getCarrierTypeOptions(carriersArray),
    [carriersArray]
  );

  // drop selections whose type disappeared after a data reload, so the map never goes empty
  const activeTypes = useMemo(
    () => selectedTypes.filter(type => options.some(o => o.value === type)),
    [selectedTypes, options]
  );

  const filteredCarriers = useMemo(
    () => filterCarriersByType(carriersArray, activeTypes),
    [carriersArray, activeTypes]
  );

  return {
    options,
    selectedTypes: activeTypes,
    setSelectedTypes,
    filteredCarriers
  };
}
